import { getPerfArms } from './perfArms';
import { PERF_SAFETY_WINDOW_EXPERIMENTS } from './perfArms.constants';

const drawDocument = (): boolean => {
  try {
    return Math.random() < 0.1;
  } catch {
    return false;
  }
};

const initializeSampling = () => {
  // These are separate per-document draws. Oversampling must never change the
  // population or volume of the existing $web_vitals series.
  const webVitals = drawDocument();
  const slowDraw = drawDocument();
  let sampleRate: 0.1 | 1 = 0.1;
  try {
    const arms = getPerfArms();
    if (arms.replayArm === 'holdout' || PERF_SAFETY_WINDOW_EXPERIMENTS.some(
      (experiment) => arms.effective[experiment] === 'treatment',
    )) sampleRate = 1;
  } catch {
    // A failed arm read retains the ordinary independent 10% draw.
  }
  const slowInteractions = sampleRate === 1 || slowDraw;
  return Object.freeze({ webVitals, slowInteractions, sampleRate, observe: webVitals || slowInteractions });
};

const sampling = initializeSampling();
export const getPerfSampling = () => sampling;
